export default {
    setPosts(state, posts) {
        state.posts = posts;
    },
    addPost(state, post) {
        state.posts.unshift(post);
    }
}